import React from 'react';
import { Box, Heading, Icon } from '@hover/blueprint';
import type { IHoverPros } from '../../../../interfaces/IHoverPros';

interface IHoverProsProps {
  title: string;
  items: IHoverPros;
}

const HoverPros: React.FC<IHoverProsProps> = ({ title, items }) => (
  <Box
    py={4}
    maxW={{ base: '100%', desktop: '4xl' }}
    flexDir="column"
    textAlign="center"
  >
    <Heading
      as="h2"
      size={{ base: 500, desktop: 700 }}
      fontWeight={700}
      sx={{ mb: 8 }}
    >
      {title}
    </Heading>
    <Box
      flexDirection={{ base: 'column', desktop: 'row' }}
      gap={8}
      alignItems="center"
    >
      {items.map(({ icon, description, key }) => (
        <Box key={key} flexDir="column" alignItems="center" flex={1}>
          <Box
            borderRadius="50%"
            bgColor="primary.100"
            alignItems="center"
            justifyContent="center"
            p={2}
            w={{ base: 10, desktop: 16 }}
            h={{ base: 10, desktop: 16 }}
          >
            <Icon
              icon={icon}
              size={{ base: 'medium', desktop: 'large' }}
              color="primary.900"
            />
          </Box>
          <Heading
            size={{ base: 300, desktop: 500 }}
            fontWeight={{ base: 400, desktop: 700 }}
            sx={{ mb: 0, mt: 4 }}
          >
            {description}
          </Heading>
        </Box>
      ))}
    </Box>
  </Box>
);

export default HoverPros;
